import { render } from "./BaseLocalePopup.vue?vue&type=template&id=77831200&scoped=true&ts=true"
import script from "./BaseLocalePopup.vue?vue&type=script&lang=ts"
export * from "./BaseLocalePopup.vue?vue&type=script&lang=ts"

import "./BaseLocalePopup.vue?vue&type=style&index=0&id=77831200&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77831200"]])

export default __exports__